import { Component, Vue } from 'types-vue'

@Component
export default class ProcessTimerSection extends Vue {}